"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Transforms an object to an array of strings, each containing a key-value pair.
 *
 * @param {Record<string, unknown>} object - The input object to be transformed.
 * @returns {string[]} An array of strings representing key-value pairs from the input object.
 *
 * @example
 *
 * // Example input object
 * const address = {
 *   city: "Deventer",
 *   company: "Drukwerkdeal",
 *   country: "NL",
 *   email: "info@drukwerkdeal.nl",
 *   phone: "0888855222",
 *   postalCode: "7418ET",
 *   streetName: "Keulenstraat",
 *   streetNumber: "4",
 *   quantity: "1000"
 * };
 *
 * // Transform the object to an array of key-value strings
 * const result = objectArrayToStringArray(address);
 *
 * // Result:
 * // [
 * //   'city:Deventer',
 * //   'company:Drukwerkdeal',
 * //   'country:NL',
 * //   'email:info@drukwerkdeal.nl',
 * //   'phone:0888855222',
 * //   'postalCode:7418ET',
 * //   'streetName:Keulenstraat',
 * //   'streetNumber:4',
 * //   'quantity:1000'
 * // ]
 */
function objectArrayToStringArray(object) {
  return Object.entries(object).map(_ref => {
    let [key, value] = _ref;
    return "".concat(key, ":").concat(String(value));
  });
}
exports.default = objectArrayToStringArray;